import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref, Ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  NavBar,
  ContextColorProvider,
  LoaderIndicator,
  HelperViewStatus,
  ButtonIconContextual,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { Hero, HeroContainer } from '@/modules/common/components/Hero';
import { TemplateHeader } from '@/modules/catalog/components/TemplateHeader';
import { TemplateStrategy } from '@/modules/catalog/components/TemplateStrategy';
import { TemplateBenefits } from '@/modules/catalog/components/TemplateBenefits';
import { About } from './components/About';
import { Performance } from './components/Performance';
import { Allocation } from './components/Allocation';
import { TermsModal } from './components/TermsModal';

import { IPortfolioSheetData } from '@/modules/catalog/services/variable-income';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import { copyToClipboard } from '@/modules/common/helpers/browser';
import { isImpersonate } from '@/modules/common/services/partner';
import { StorageKeys } from '@/modules/common/services/local-storage';
import { CustomerModule } from '@/modules/common/store/CustomerModule';


export default /*#__PURE__*/_defineComponent({
  __name: 'Template',
  setup(__props) {

const router = useRouter();

const fetchPortfolioSheetData = inject('fetchPortfolioSheetData', () => ({}));

const acceptTerms = inject('acceptTerms', (request: string) => ({ request }));

const portfolioSheetData = inject(
  'portfolioSheetData'
) as Ref<IPortfolioSheetData>;
const isLoading = inject('isLoading') as Ref<boolean>;
const hasError = inject('hasError') as Ref<boolean>;
const templateId = inject('templateId') as Ref<string>;

const isTermsModalOpen = ref(false);

const headerImages = computed(() => {
  return {
    small: portfolioSheetData.value?.header?.image?.small,
    regular: portfolioSheetData.value?.header?.image?.regular,
    full: portfolioSheetData.value?.header?.image?.full
  };
});

const templateHeaderData = computed(() => {
  return {
    title: portfolioSheetData.value?.header?.title ?? '-',
    description: portfolioSheetData.value?.header?.description ?? '-',
    isManagedByWarren: portfolioSheetData.value?.header?.isManagedByWarren
  };
});

const showButtonContainer = computed(() => {
  return !isLoading.value && !hasError.value && portfolioSheetData.value?.terms;
});

const buttonLabel = computed(() => {
  return portfolioSheetData.value?.hasPortfolioCreated
    ? 'Você já possui essa carteira'
    : 'Investir';
});

const disableAcquisitionButton = computed(() => {
  return portfolioSheetData.value?.hasPortfolioCreated || hasImpersonate.value;
});

const hasImpersonate = computed(() => {
  const isImpersonateByIntranet = localStorage.getItem(
    StorageKeys.isImpersonateByIntranet
  );

  return isImpersonate() || isImpersonateByIntranet === 'true';
});

const isRegulatoryStatusBlocked = computed(
  () => CustomerModule.isRegulatoryStatusBlocked
);

function handleShareButtonClick() {
  copyToClipboard(window.location.href);
  notify({
    group: 'wrn-notifications',
    text: 'Link copiado com sucesso.',
    type: NotificationTypes.success
  });
}

function handleTermsModal() {
  if (isRegulatoryStatusBlocked.value) {
    return router.push({ name: 'wealth', query: { regulatoryModal: 'true' } });
  }

  isTermsModalOpen.value = !isTermsModalOpen.value;
}

function goBack() {
  router.push({ name: 'catalog' });
}

return { __sfc: true,router, fetchPortfolioSheetData, acceptTerms, portfolioSheetData, isLoading, hasError, templateId, isTermsModalOpen, headerImages, templateHeaderData, showButtonContainer, buttonLabel, disableAcquisitionButton, hasImpersonate, isRegulatoryStatusBlocked, handleShareButtonClick, handleTermsModal, goBack, NavBar, ContextColorProvider, LoaderIndicator, HelperViewStatus, ButtonIconContextual, ButtonContainer, ButtonPrimary, BackButton, Hero, HeroContainer, TemplateHeader, TemplateStrategy, TemplateBenefits, About, Performance, Allocation, TermsModal }
}

})